type DeleteHourlyBudgetModalProps = {
  isOpen: boolean;
  hourlyBudget: string;
  deleting: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteHourlyBudgetModal({
  isOpen,
  hourlyBudget,
  deleting,
  error,
  onConfirm,
  onCancel,
}: DeleteHourlyBudgetModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={deleting ? undefined : onCancel}
    >
      <div
        className="bg-surface rounded-xl max-w-sm w-full p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-base font-semibold text-foreground mb-2">Remove hourly budget?</h3>
        <p className="text-sm text-foreground-muted mb-4">
          Remove the hourly budget configuration
          {hourlyBudget ? (
            <>
              {' '}
              (base <strong>{hourlyBudget}</strong>)
            </>
          ) : null}
          ? The scheduled job will stop incrementing this campaign&apos;s daily budget. Run history
          will also be cleared. This cannot be undone.
        </p>
        {error && <p className="text-sm text-error mb-3">{error}</p>}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={deleting}
            className="px-3 py-2 text-sm rounded-lg border border-border hover:bg-page disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={deleting}
            className="px-3 py-2 text-sm rounded-lg bg-error text-white hover:bg-error disabled:opacity-50"
          >
            {deleting ? 'Removing...' : 'Remove'}
          </button>
        </div>
      </div>
    </div>
  );
}
